import {
  atom,
  useRecoilState,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import { localStorageEffect } from "utils/localStorageUtils";

const localStorageKey = "sda";

const authDataState = atom({
  key: "AuthDataState",
  default: {
    token: "",
    isLoggedIn: false,
  },
  effects: [localStorageEffect(localStorageKey)],
});

export const useAuthDataState = () => useRecoilState(authDataState);
export const useSetAuthDataState = () => useSetRecoilState(authDataState);
export const useResetAuthDataState = () => useResetRecoilState(authDataState);
export const getToken = (): string | null => {
  const authState = localStorage.getItem(localStorageKey);
  if (authState) {
    const parsedState = JSON.parse(authState);
    return parsedState.token;
  }
  return null;
};
